export default __webpack_public_path__ + "delete-icon.svg";